import(/* webpackMode: "eager" */ "/home/runner/work/kawaak/kawaak/apps/pulse/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/kawaak/kawaak/apps/pulse/app/providers.tsx");
